import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',
}) => {
  // Responsive sizes: nearly full-width on mobile, constrained on larger screens
  const sizes = {
    sm: 'max-w-[calc(100vw-1rem)] sm:max-w-md',
    md: 'max-w-[calc(100vw-1rem)] sm:max-w-lg',
    lg: 'max-w-[calc(100vw-1rem)] sm:max-w-xl md:max-w-2xl',
    xl: 'max-w-[calc(100vw-1rem)] sm:max-w-xl md:max-w-2xl lg:max-w-4xl',
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-2 sm:p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={`
                  w-full ${sizes[size]}
                  transform overflow-hidden rounded-xl sm:rounded-2xl
                  bg-white p-4 sm:p-6 shadow-xl
                  transition-all
                `}
              >
                {title && (
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-semibold text-gray-900 mb-4"
                  >
                    {title}
                  </Dialog.Title>
                )}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
